import { render, staticRenderFns } from "./CandidateDetails.vue?vue&type=template&id=f95f1216&"
import script from "./CandidateDetails.vue?vue&type=script&lang=js&"
export * from "./CandidateDetails.vue?vue&type=script&lang=js&"
import style0 from "./CandidateDetails.vue?vue&type=style&index=0&id=f95f1216&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports